export default __webpack_public_path__ + "static/media/943.4c81f351.png";